import React, { createRef } from "react"
import { connect } from "react-redux"
import { graphql } from "gatsby"
import get from "lodash/get"
import Accordion from "../components/global/accordion"
import PaymentAccordion from "../components/global/paymentAccordion"
import { INLINES } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

import {
  setInitialPageLoad,
  setShowAnnoucementBar,
  setAnnouncementBarData,
} from "../state/global"

import { initializeCheckout } from "../state/shop"

import Layout from "../components/global/layout"
import SEO from "../components/global/seo"
import Footer from "../components/global/footer"
import NavBar from "../components/global/navBar"
import ShopHeader from "../components/shop/shopHeader"
import HiddenClocks from "../components/global/hiddenClocks"
import SoftFooter from "../components/global/softFooter"
import SiteCredit from "../components/global/siteCredit"

import Cart from "../components/shop/cart"
import Product from "../components/shop/product"
import ShopPopup from "../components/global/shopPopup"

import { mergeProductData, isBrowser, getSlug, slugify } from "../lib"

class ShopPage extends React.Component {
  constructor(props) {
    super(props);

    this.cartRef = createRef();
    this.containerRef = createRef();
 
    this.state = {
      cartOpen: false,
      cartLocation: null
    }

  }


  componentDidMount() {
    this.props.dispatch(initializeCheckout())

    console.log("containerRef",this.containerRef);
    console.log("cartRef",this.cartRef);
  }


  handleCartRef = r => {
    this.setState({ cartLocation: r.current })
    this.cartRef.current = r;
  };


  handleScrollToRef(ref) {
    
    if (isBrowser() && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" })
    }
  }

  handleViewCartClick() {

    this.setState(
      {
        cartOpen: true
      },
      () => setTimeout(() => this.handleScrollToRef(this.cartRef), 50)
    )
  }

  render() {



    let announcement = get(
      this,
      "props.data.allContentfulAnnouncementBar.edges"
    )


    announcement = announcement.map(i => i.node)[0]
    let json = announcement.childContentfulAnnouncementBarBodyRichTextNode.json

    const options = {
      renderNode: {
        [INLINES.ENTRY_HYPERLINK]: node => {
          const link = node.data.target.fields.slug["en-US"]
          const title = node.data.target.fields.title["en-US"]

          return (
            <a target="_blank" rel="noopener noreferrer" href={link}>
              {title}
            </a>
          )
        },
      },
    }

    if (announcement && this.props.initialPageLoad) {
      this.props.dispatch(setShowAnnoucementBar(false))
      this.props.dispatch(setInitialPageLoad(false))
      this.props.dispatch(
        setAnnouncementBarData({
          type: "announcement",
          title: announcement.title,
          info: documentToReactComponents(json, options),
        })
      )
    }




    const { featuredMedia, productsAndCollections } = this.props
    const { seoTitle } = this.props.seo
    const { checkout } = this.props.shop
    const { products, collections } = this.state

    const totalItems = checkout.lineItems.reduce(
      (acc, item) => acc + item.quantity,
      0
    )


    return (
      <Layout>
        <SEO title={seoTitle} />
        <div
          ref={this.containerRef}
          className={`body-container ${this.props.dragging ? "minimize" : ""}`}
        >

        <NavBar shop containerRef={this.containerRef}/>

        <HiddenClocks />
          {/* <ShopHeader featuredMedia={featuredMedia} /> */}


          {productsAndCollections
            .sort((a, b) => a.idx - b.idx)
            .map(x => {
              const collectionSlug = slugify(x.title);
              return (
                <Accordion 
                  containerRef={this.containerRef}
                  slug={collectionSlug}
                  key={x.title}
                  id={x.idx + 1} 
                  title={x.title}
                  nested
                 >


                  {x.products ? (
                    x.products.map(p => <Product 
                      key={p.title} 
                      product={p}
                      collectionSlug={collectionSlug}
                      containerRef={this.containerRef}
                    />)
                  ) : (
                    <Product 
                       key={x.title} 
                       product={x}
                       collectionSlug={collectionSlug}
                       containerRef={this.containerRef}
                    />
                  )}
                </Accordion>
              )
            })}



          <PaymentAccordion
            id={productsAndCollections.length + 1}
            title={`Shopping Cart (${totalItems})`}
            isOpen={checkout.lineItems.length > 0 || this.state.cartOpen}
            cart
          >
              <div className="cart-container">
              {/* SPACER TO MATCH TITLES ABOVE */}
              <span className="h1 spacer" style={{ visibility: "hidden" }}>
                &nbsp;
              </span>

              <Cart 
                refProp={this.cartRef}
              />


            </div>
          </PaymentAccordion>


          <SoftFooter shop />
          <Footer />
          <SiteCredit />
        </div>
        <ShopPopup handleClick={() => this.handleViewCartClick(this.cartRef)} />
      </Layout>
    )
  }
}
export default connect((state, ownProps) => {
  const productVariants = get(ownProps, "data.allShopifyProductVariant.nodes")
  const contentfulProductsAndCollections = get(
    ownProps,
    "data.contentfulShopPage.productsAndCollections"
  )

  const collections = contentfulProductsAndCollections
    .map((x, idx) => {
      if (x.__typename === "ContentfulProductCollection") {
        return {
          idx,
          slug: x.slug,
          title: x.title,
          products: x.products.map(p => mergeProductData(p, productVariants)),
        }
      } else {
        return null
      }
    })
    .filter(x => !!x)

  const products = contentfulProductsAndCollections
    .map((x, idx) => {
      if (x.__typename === "ContentfulProduct") {
        return {
          idx,
          ...mergeProductData(x, productVariants),
        }
      } else {
        return null
      }
    })
    .filter(x => !!x)

  const seoTitle = get(ownProps, "data.contentfulShopPage.title")
  const seoDescription = get(ownProps, "data.contentfulShopPage.seoDescription")
  const seoImage = get(ownProps, "data.contentfulShopPage.socialImage.file.url")
  const featuredMedia = get(ownProps, "data.contentfulShopPage.featuredMedia")

  return {
    mobile: state.global.mobile,
    dragging: state.navbar.dragging,
    initialPageLoad: state.global.initialPageLoad,
    shop: state.shop,
    seo: {
      seoTitle,
      seoDescription,
      seoImage,
    },
    featuredMedia,
    productsAndCollections: [...collections, ...products],
  }
}, 
null,
null,
{forwardRef: true}
)(ShopPage)

export const shopQuery = graphql`
  query {
    allContentfulAnnouncementBar {
      edges {
        node {
          title
          childContentfulAnnouncementBarBodyRichTextNode {
            json
          }
        }
      }
    }
    contentfulShopPage(contentful_id: { eq: "3ySHiYqk2K0AeBr8tz3RBC" }) {
      title
      seoDescription
      socialImage {
        file {
          url
        }
      }
      featuredMedia {
        ... on ContentfulFeaturedVideo {
          id
          __typename
          title
          video {
            file {
              url
            }
          }
        }
        ... on ContentfulFeaturedImage {
          id
          __typename
          mobileImage {
            title
            fluid(quality: 99, maxWidth: 2000) {
              ...GatsbyContentfulFluid
            }
          }
          desktopImage {
            title
            fluid(quality: 99, maxWidth: 2000) {
              ...GatsbyContentfulFluid
            }
          }
        }
      }
      productsAndCollections {
        ... on ContentfulProduct {
          __typename
          id
          productDetails
          shopifyProduct
        }
        ... on ContentfulProductCollection {
          __typename
          id
          title
          slug
          products {
            id
            shopifyProduct
            productDetails
          }
        }
      }
    }
    allShopifyProductVariant {
      nodes {
        shopifyId
        product {
          id
          shopifyId
          title
          description
          descriptionHtml
          availableForSale
          priceRange {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          options {
            id
            name
            values
          }
          variants {
            id
            title
            price
            availableForSale
            shopifyId
            selectedOptions {
              name
              value
            }
            image {
              id
            }
          }
          images {
            id
            localFile {
              childImageSharp {
                fluid(quality: 90, maxWidth: 1200, webpQuality: 90) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    }
  }
`
